import { BaseDto } from "src/dtos/common/baseDto";
import { formatDate } from "src/utils/string/stringUtil";

export interface SalesDto {
	salesBillHeaderDto: SalesHeaderDto;
	salesBillDetailDtoList: SalesDetailDto[];
}

export interface SalesHeaderDto extends BaseDto {
	salBillNo:		string;					// 매출전표번호, 수정 시에 필요함
	compCd:			string;					// 사업장 코드
	compNm:			string;					// 사업장 이름
	customCd:		string;					// 거래처 코드
	customNm:		string;					// 거래처 이름
	salesDt:		string | undefined;		// 매출일자
	deliveryDt:		string | undefined;		// 출고일자
	vatType:		string;					// 부가세 구분
	moneyCd:		string;					// 기준화폐 (거래처에서 가져와야 함)
	salesAmt:		number;					// 공급가액 (BigDecimal을 number로 변환)
	vatAmt:			number;					// 부가세
	totalAmt:		number;					// 공급총액
	post:			string;					// 우편번호
	address:		string;					// 주소
	detailAddress:	string;					// 상세주소
	periodDt:		string | undefined;		// 마감일자
	telNo:			string;					// 전화
	faxNo:			string;					// 팩스
	taxBilling:		string;					// 세금계산서발행여부
	taxBillNo:		string;					// 세금계산서발행no
	empNo:			string;					// 매출담당자
	empNm:			string;					// 매출담당자 이름
	approveFlg:		string;					// 전표승인
	transportNo?:	string;					// 수불번호
	remark:			string;					// 비고

	inserted:		boolean					// 생성여부
	isModified:		boolean					// 수정여부
}

export const defaultSalesHeaderDto: SalesHeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	salBillNo: '',
	compCd: '',
	compNm: '',
	customCd: '',
	customNm: '',
	vatType: '',
	salesDt: formatDate(new Date()),
	deliveryDt: formatDate(new Date()),
	post: '',
	address: '',
	detailAddress: '',
	moneyCd: '',
	salesAmt: 0,
	vatAmt: 0,
	totalAmt: 0,
	periodDt: formatDate(new Date()),
	telNo: '',
	faxNo: '',
	taxBilling: 'N',
	taxBillNo: '',
	empNo: '',
	empNm: '',
	approveFlg: 'N',
	transportNo: '',
	remark: '',

	inserted: false,
	isModified: false,
}



export interface SalesDetailDto extends BaseDto {
	salBillNo:		string;					// 매출번호
	itemNo:			string;					// 항목번호

	compCd:			string;					// 사업장코드
	compNm:			string;					// 사업장명
	salesDt:		string | undefined;		// 매출일자
	customCd:		string;					// 거래처코드
	customNm:		string;					// 거래처명
	itemSeq:		number;					// 순서
	itemCd:			string;					// 품목코드
	itemNm:			string;					// 품명
	itemSpec:		string;					// 규격
	modelNo:		string;					// 품번
	unit:			string;					// 단위 / unit
	salesQty:		number;					// 수량
	salesPrice:		number;					// 단가
	dcAmt:			number;					// 할인액
	itemAmt:		number;					// 매출액
	transportNo:	string;					// 수불번호
	remark:			string;					// 비고

	inserted:		boolean;				// 생성여부
	isModified:		boolean;				// 수정여부
	
}


export const defaultSalesDetailDto: SalesDetailDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	salBillNo: '',
	itemNo: '',
	compCd: '',
	compNm: '',
	salesDt: formatDate(new Date()),
	customCd: '',
	customNm: '',
	itemSeq: 0,
	itemNm: '',
	itemSpec: '',
	modelNo: '',
	itemCd: '',
	unit: '',
	salesQty: 0,
	salesPrice: 0,
	dcAmt: 0,
	itemAmt: 0,
	transportNo: '',
	remark: '',

	inserted: false,
	isModified: false,
}
